import styles from './styles.module.scss';

interface MobileTableProps {
  children: React.ReactNode;
}

export const MobileTable: React.FC<MobileTableProps> = ({ children }) => {
  return <div className={styles.dealTable}>{children}</div>;
};
